document.addEventListener('DOMContentLoaded', () => {
    const increaseButton = document.querySelector('.quantity .qty-increase');
    const decreaseButton = document.querySelector('.quantity .qty-decrease');
    const quantityInput = document.querySelector('.quantity .qty');

    if ( increaseButton ) {
        increaseButton.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value);
            quantityInput.value = currentValue + 1;
        });
    }

    if ( decreaseButton ) {
        decreaseButton.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value);
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
    }
});
